import { useEffect, useState } from 'react';
import StepperControl from './components/StepperControl';
import Card from 'components/card';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import Checkbox from 'components/checkbox';
import Select from 'react-select';
import InputField from 'components/fields/InputField';
import { allChannels, frenchAreas } from 'variables/industries';
import { useIndustries } from 'services/industryService';
import { ChannelIcon } from 'components/icons';
import { MdOutlineWhatsapp } from 'react-icons/md';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import SignUpModal from '../../buyer/sellerOffer/components/SignUpModal';

const MySwal = withReactContent(Swal);

const ProductNew = () => {
    const { industries: industriesData, loading: industriesLoading } = useIndustries();
    const [currentStep, setCurrentStep] = useState(1);
    const [error, setError] = useState('');
    const [offerCreated, setOfferCreated] = useState(false);

    const [channels, setChannels] = useState([]);
    const [industry, setIndustry] = useState('Rénovation');
    const [subIndustry, setSubIndustry] = useState('Pompe à chaleur');
    const [fields, setFields] = useState([]);
    const [user, setUser] = useState<any>(null);
    const [accountCreated, setAccountCreated] = useState(false);
    const [hasInteracted, setHasInteracted] = useState(false);
    const [showSignUpModal, setShowSignUpModal] = useState(false);

    const [offer, setOffer] = useState<any>({
        type: 'leads',
        channels: [],
        industry: 'Rénovation',
        subIndustry: 'Pompe à chaleur',
        regions: ['Toute la France'],
        fields: ['prénom', 'nom', 'email', 'téléphone'],
        whiteLabelInfos: '',
        weeklyQuantity: '',
        targetPrice: '10-15',
        franceOnly: true,
        //leadNbr: "",
    });

    const handlechange = (e: any) => {
        const { id, value } = e.target;
        setError('');

        // Handle limitation
        if (id === 'weeklyQuantity' && Number(value) < 40) {
            setOffer({ ...offer, [id]: 40 });
            setError('La quantité minimale est de 40 leads');
        } else if (id === 'weeklyQuantity' && Number(value) > 500) {
            setOffer({ ...offer, [id]: 500 });
            setError('La quantité maximale est de 500 leads');
        } else {
            setOffer({ ...offer, [id]: value });
        }
    };

    const getPricing: any = () => {
        const foundIndustry = industriesData.find(i => i.name === industry);
        if (foundIndustry && foundIndustry.pricing.length > 0) {
            return foundIndustry.pricing;
        }
        // Fallback pricing if industry not found
        return ['5-10', '10-15', '15-20', '20-30', '30-50', '50-100', '100+'];
    };

    const handleFieldsChange = (e: any) => {
        const { id, checked } = e.target;
        let newFields = [...fields, id];
        newFields = [
            ...new Set([...newFields, ...['Téléphone', 'Nom', 'Prénom']]),
        ];

        if (checked) {
            setFields(newFields);
        } else {
            newFields = fields.filter((fields) => fields !== id);
            setFields(newFields);
        }
        let newE = {
            target: {
                id: 'fields',
                value: newFields,
            },
        };
        handlechange(newE);
    };

    const handleChannelChange = (e: any) => {
        const { id, checked } = e.target;
        let newChannels = [...channels, id];
        if (checked) {
            setChannels(newChannels);
        } else {
            newChannels = channels.filter((channel) => channel !== id);
            setChannels(newChannels);
        }
        let newE = {
            target: {
                id: 'channels',
                value: newChannels,
            },
        };
        handlechange(newE);
    };

    const handleIndustryChange = (e: any) => {
        const { value } = e.target;
        const selectedIndustry = industriesData.find(i => i.name === value);
        
        setIndustry(value);
        if (selectedIndustry && selectedIndustry.subIndustries.length > 0) {
            setSubIndustry(selectedIndustry.subIndustries[0].name);
            setOffer({
                ...offer,
                industry: value,
                subIndustry: selectedIndustry.subIndustries[0].name,
            });
        } else {
            setSubIndustry('');
            setOffer({
                ...offer,
                industry: value,
                subIndustry: '',
            });
        }
    };

    const handleSubIndustryChange = (e: any) => {
        const { value } = e.target;
        setSubIndustry(value);
        handlechange(e);
    };

    const handleQuickSelect = (areas: string[], label: string) => {

        // Remove "Toute la France" and "Toute la Belgique" from current regions
        const currentRegions = offer.regions.filter(
            (region: string) =>
                region !== 'Toute la France' && region !== 'Toute la Belgique'
        );

        // Add new areas to current regions, avoiding duplicates
        const newRegions = [...new Set([...currentRegions, ...areas])];

        const newE = {
            target: {
                id: 'regions',
                value: newRegions,
            },
        };
        handlechange(newE);
    };

    const handleClearAll = () => {

        const newE = {
            target: {
                id: 'regions',
                value: [] as string[],
            },
        };
        handlechange(newE);
    };

    const initUser = () => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        };
        axios
            .get(`${CONFIG.apiUrl}/user/me`, config)
            .then((res) => {
                setUser(res.data);
                // Guest popup will be triggered on first interaction instead
            })
            .catch((err) => {
                console.log('No user info found', err);
            });
    };

    const loginGoogle = (token: string) => {
        axios
            .post(`${CONFIG.apiUrl}/auth/google`, { token })
            .then((response: any) => {
                if (response.data.token) {
                    localStorage.setItem('token', response.data.token);
                    localStorage.setItem('user-type', response.data.type);
                    window.location.href = '/admin/dashboard';
                }
            })
            .catch((error: any) => {
                console.log(error);
            });
    };

    const updateProfil = async (email: string) => {
        const token = localStorage.getItem('token');
        const config = {
            headers: { Authorization: `Bearer ${token}` },
        };
        const data = { email };
        try {
            const result: any = await axios.put(
                `${CONFIG.apiUrl}/user`,
                data,
                config
            );
            if (result.status === 200) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error('Error updating profile:', error);
            return false;
        }
    };

    const openGuestPopUp = () => {
        setShowSignUpModal(true);
    };

    useEffect(() => {
        window.localStorage.setItem('industry', industry);
        initUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const steps = [
        { stepNo: 1, name: 'Créer une offre', error: error },
        { stepNo: 2, name: 'Pricing', error: error },
    ];

    const createOffer = () => {
        if (offerCreated) return;
        const token = localStorage.getItem('token');
        const config = {
            headers: { Authorization: `Bearer ${token}` },
        };
        setOfferCreated(true);
        axios
            .post(`${CONFIG.apiUrl}/offer`, offer, config)
            .then((res: any) => {
                // if (user.role === 'paying-user')
                //     window.location.href = '/admin/my-request?created=true';
                // else window.location.href = '/admin/my-request?not-paid=true';
                window.location.href = '/admin/my-request?created=true';
            })
            .catch((err: any) => {
                setError(err.response.data.error);
                setOfferCreated(false);
            });
    };

    const handleClick = (direction: string) => {

        console.log(offer);
        let newStep = currentStep;

        direction === 'next' ? newStep++ : newStep--;
        // check if steps are within bounds
        if (newStep > 0 && newStep <= steps.length) {
            const hasCountryWideSelection = offer.regions.some((region: string) => 
                region.includes('Toute')
            );
            const hasClimateZone = offer.regions.some((region: string) => 
                region.includes('Zone Climatique')
            );
            
            if (
                offer.regions.length < 7 && 
                !hasCountryWideSelection &&
                !hasClimateZone
            ) {
                setError(
                    'Si vous opérez sur moins de 7 départements ou si vous souhaitez passer une commande inférieure à 40 leads, nous vous recommandons de procéder via un ordre d’achat.'
                );
                return;
            }
            if (offer.channels.length > 0) setCurrentStep(newStep);
            else setError('Veuillez remplir tous les champs obligatoires');
        }
        if (newStep === 3) {
            if (
                user &&
                user.email &&
                user.email.includes('guest')
            ) {
                setHasInteracted(true);
                openGuestPopUp();
           } else {
                createOffer();
            }
        }
    };

    return (
        <div className="mt-3 h-full w-full">
            {industriesLoading ? (
                <div className="flex h-screen items-center justify-center">
                    <div className="text-center">
                        <div className="text-lg text-navy-700 dark:text-white">Chargement des industries...</div>
                    </div>
                </div>
            ) : (
                <>
            {/* Header Section */}
            <div className="mb-6 rounded-[20px] border border-gray-200/50 bg-gradient-to-br from-purple-100 via-purple-50 to-purple-100 p-8 shadow-lg dark:border-white/10 dark:from-navy-800 dark:to-navy-900">
                {/* Title and subtitle */}
                <div className="mb-6">
                    <h1 className="mb-2 text-[32px] font-bold leading-tight text-gray-900 dark:text-white">
                        Faire une commande
                    </h1>
                    <p className="text-base text-gray-600 dark:text-gray-400">
                        La commande ferme avec livraison garantie. Choisissez votre canal, définissez votre range de prix et recevez vos leads sous 1 semaine.
                    </p>
                </div>

                {/* Two info boxes */}
                <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
                    {/* Comment ça marche */}
                    <div className="rounded-[16px] border border-gray-200/50 bg-white/60 p-6 backdrop-blur-sm dark:border-white/10 dark:bg-navy-800/60">
                        <h3 className="mb-4 flex items-center gap-2 text-lg font-bold text-gray-900 dark:text-white">
                            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-100 text-lg dark:bg-blue-900/30">
                                ℹ️
                            </span>
                            Comment ça marche ?
                        </h3>

                        <div className="space-y-3">
                            <div className="flex items-start gap-3">
                                <span className="mt-1 font-bold text-leadrs">✓</span>
                                <div className="text-sm text-gray-700 dark:text-gray-300">
                                    <strong>Range de prix :</strong> Définissez une fourchette de prix par lead (le vendeur fixe le prix final dans ce range)
                                </div>
                            </div>
                            <div className="flex items-start gap-3">
                                <span className="mt-1 font-bold text-leadrs">✓</span>
                                <div className="text-sm text-gray-700 dark:text-gray-300">
                                    <strong>Canal ciblé :</strong> Sélectionnez le canal d'acquisition de votre choix (Google Ads, Facebook, etc.)
                                </div>
                            </div>
                            <div className="flex items-start gap-3">
                                <span className="mt-1 font-bold text-leadrs">✓</span>
                                <div className="text-sm text-gray-700 dark:text-gray-300">
                                    <strong>Définissez votre zone :</strong> Minimum 7 départements et 40 leads par commande
                                </div>
                            </div>
                            <div className="flex items-start gap-3">
                                <span className="mt-1 font-bold text-leadrs">✓</span>
                                <div className="text-sm text-gray-700 dark:text-gray-300">
                                    <strong>Validation vendeur :</strong> Un vendeur accepte votre commande et la mission démarre
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Les avantages */}
                    <div className="rounded-[16px] border border-gray-200/50 bg-white/60 p-6 backdrop-blur-sm dark:border-white/10 dark:bg-navy-800/60">
                        <h3 className="mb-4 flex items-center gap-2 text-lg font-bold text-gray-900 dark:text-white">
                            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-green-100 text-lg dark:bg-green-900/30">
                                ✨
                            </span>
                            Les avantages
                        </h3>

                        <div className="space-y-3">
                            <div className="flex items-start gap-3">
                                <span className="text-lg">⚡</span>
                                <div className="text-sm text-gray-700 dark:text-gray-300">
                                    <strong>Rapidité garantie :</strong> Livraison sous 1 semaine maximum après validation
                                </div>
                            </div>
                            <div className="flex items-start gap-3">
                                <span className="text-lg">🎯</span>
                                <div className="text-sm text-gray-700 dark:text-gray-300">
                                    <strong>Canal ciblé :</strong> Vous choisissez précisément la source de vos leads
                                </div>
                            </div>
                            <div className="flex items-start gap-3">
                                <span className="text-lg">💰</span>
                                <div className="text-sm text-gray-700 dark:text-gray-300">
                                    <strong>Budget prévisible :</strong> Range de prix défini à l'avance, pas de surprise
                                </div>
                            </div>
                            <div className="flex items-start gap-3">
                                <span className="text-lg">🎯</span>
                                <div className="text-sm text-gray-700 dark:text-gray-300">
                                    <strong>Leads 100% exclusifs :</strong> Un seul acheteur par lead, toujours
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="mx-auto h-full lg:px-3">
                <Card extra={'h-full mx-auto border pb-3'}>
                    <div className="rounded-[20px]">
                        {/* Stepper One */}
                        <div
                            className={`${
                                steps[currentStep - 1].stepNo === 2 && 'hidden'
                            } h-full w-full rounded-[20px] px-3 pt-7 md:px-8`}
                        >
                            {/* Header */}

                            {/* Error message */}
                            {error && (
                                <div className="z-10 ml-1 mt-2 items-center font-poppins text-[14px] text-red-500">
                                    {error}.
                                </div>
                            )}

                            {/* content */}
                            {/* inputs */}
                            <div className="grid grid-cols-2 gap-3">
                                <div className="col-span-2 md:col-span-1">
                                    {/* Type */}
                                    <div className="mb-0">
                                        <label
                                            htmlFor="currency"
                                            className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
                                        >
                                            Départements*
                                        </label>
                                        <div className="mt-2 w-full rounded-xl px-2.5 py-3 text-sm text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800">
                                            <Select
                                                value={offer.regions.map(
                                                    (region: string) => ({
                                                        value:
                                                            region ===
                                                            'Toute la France'
                                                                ? 'france'
                                                                : region,
                                                        label: region,
                                                    })
                                                )}
                                                isMulti
                                                onChange={(items) => {
                                                    const regions: any = [];
                                                    items.map((item) =>
                                                        regions.push(
                                                            item.value ===
                                                                'france'
                                                                ? 'Toute la France'
                                                                : item.value
                                                        )
                                                    );

                                                    let newE = {
                                                        target: {
                                                            id: 'regions',
                                                            value: regions,
                                                        },
                                                    };
                                                    handlechange(newE);
                                                }}
                                                name="colors"
                                                options={frenchAreas.map(
                                                    (item) => ({
                                                        value:
                                                            item ===
                                                            'Toute la France'
                                                                ? 'france'
                                                                : item,
                                                        label: item,
                                                    })
                                                )}
                                                className="w-full"
                                                classNamePrefix="select"
                                            />
                                        </div>
                                        <p className='text-xs mr-4 ml-4'> Minimum 7 départements</p>
                                    </div>
                                    {/* channels */}
                                    <div className="mt-3">
                                        <label
                                            htmlFor="currency"
                                            className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
                                        >
                                            Canaux d'acquisition*
                                        </label>

                                        <div className="ml-3 mt-4 grid grid-cols-2 gap-2 xl:grid-cols-3">
                                            {allChannels.map((channel) => (
                                                <div className="col-span-1 flex">
                                                    <Checkbox
                                                        defaultChecked={false}
                                                        id={channel}
                                                        onChange={
                                                            handleChannelChange
                                                        }
                                                    />
                                                    <div className="ml-2">
                                                        <ChannelIcon
                                                            channel={channel}
                                                        />
                                                    </div>
                                                    <p className="ml-1 text-xs">
                                                        {channel}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                        <p
                                            className="ml-3 mt-3 text-sm text-leadrs underline hover:cursor-pointer"
                                            onClick={() =>
                                                window.open(
                                                    '/admin/channels-info',
                                                    '_blank'
                                                )
                                            }
                                        >
                                            J’ai besoin d’aide pour choisir mes
                                            canaux d’acquisition
                                        </p>
                                    </div>
                                </div>
                                {/* right side */}
                                <div className="col-span-2 md:col-span-1">
                                    {/* Type */}
                                    <div className="mb-0 mt-4">
                                        <label
                                            htmlFor="currency"
                                            className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
                                        >
                                            Industrie*
                                        </label>
                                        <div className="mt-2 w-full rounded-xl border border-gray-200 px-2.5 py-3 text-sm text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800">
                                            <select
                                                id="industry"
                                                className="mb-0 w-full bg-white dark:!bg-navy-800"
                                                onChange={handleIndustryChange}
                                            >
                                                {industriesData.map((item) => (
                                                    <option key={item._id} value={item.name}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    {/* Sous-Industrie */}
                                    <div className="mb-0 mt-5">
                                        <label
                                            htmlFor="currency"
                                            className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
                                        >
                                            Produit*
                                        </label>
                                        <div className="mt-2 w-full rounded-xl border border-gray-200 px-2.5 py-3 text-sm text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800">
                                            <select
                                                id="subIndustry"
                                                className="mb-0 w-full bg-white dark:!bg-navy-800"
                                                onChange={
                                                    handleSubIndustryChange
                                                }
                                            >
                                                {industriesData
                                                    .find(i => i.name === industry)
                                                    ?.subIndustries.map((item: any) => (
                                                        <option
                                                            key={item.name}
                                                            value={item.name}
                                                        >
                                                            {item.name}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>

                                    {(industry === 'Autre' ||
                                        subIndustry === 'Autre') && (
                                        <div className="mb-0 ml-2 mt-2">
                                            <label
                                                htmlFor={'others'}
                                                className={`ml-1.5 text-sm font-bold text-navy-700 dark:text-white`}
                                            >
                                                Autre
                                            </label>
                                            <p className="mt-2 text-sm">
                                                Contactez charlotte@leadrs.co
                                                pour ajouter votre industrie sur
                                                Leadrs
                                            </p>
                                        </div>
                                    )}

                                    {/* SSous-sous-Industrie */}
                                    {/* find element in industries[industry] who contain subIndustry */}
                                    {industriesData
                                        .find(i => i.name === industry)
                                        ?.subIndustries.find((item: any) => item.name === subIndustry)
                                        ?.sub && industriesData
                                        .find(i => i.name === industry)
                                        ?.subIndustries.find((item: any) => item.name === subIndustry)
                                        ?.sub.length > 0 && (
                                        <div className="mb-0 mt-3">
                                            <label
                                                htmlFor="currency"
                                                className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
                                            >
                                                Détails sous-industrie*
                                            </label>
                                            <div className="mt-2 w-full rounded-xl border border-gray-200 px-2.5 py-3 text-sm text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800">
                                                <select
                                                    id="subIndustry"
                                                    className="mb-0 w-full bg-white dark:!bg-navy-800"
                                                    onChange={handlechange}
                                                >
                                                    {/* Find industries[industry] where name === subIndustry */}
                                                    {industriesData
                                                        .find(i => i.name === industry)
                                                        ?.subIndustries.map((item: any) => {
                                                            if (item.name === subIndustry) {
                                                                return item.sub?.map((subItem: any) => (
                                                                    <option
                                                                        key={subItem}
                                                                        value={subItem}
                                                                    >
                                                                        {subItem}
                                                                    </option>
                                                                ));
                                                            }
                                                            return null;
                                                        })}
                                                </select>
                                            </div>
                                        </div>
                                    )}

                                    {/* text area */}
                                    {/* <div className="mt-5">
                                        <TextField
                                            label="Argument de vente*"
                                            placeholder="Avantage concurentiel, script commercial, ..."
                                            id="whiteLabelInfos"
                                            onChange={handlechange}
                                            cols={30}
                                            rows={4}
                                        />
                                    </div>
                                    <div className="mt-7">
                                        <TextField
                                            label="Site concurrents"
                                            placeholder="pompes-chaleur.com, pompes-a-chaleur.fr, ..."
                                            id="competitors"
                                            onChange={handlechange}
                                            cols={30}
                                            rows={4}
                                        />
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        {/* Stepper Two */}
                        <div
                            className={`${
                                steps[currentStep - 1].stepNo === 1 && 'hidden'
                            } h-full w-full rounded-[20px] px-3 pt-7 md:px-8`}
                        >
                            {/* Header */}
                            <h1 className="pt-[5px] text-xl font-bold text-navy-700 dark:text-white">
                                Pricing
                            </h1>
                            {/* Error message */}
                            {error && (
                                <div className="z-10 ml-1 mt-2 items-center font-poppins text-[14px] text-red-500">
                                    {error}.
                                </div>
                            )}
                            {/* inputs */}
                            <div className="mt-10 grid h-full w-full grid-cols-2 gap-3">
                                {/* left side */}
                                <div className="col-span-12 grid w-full grid-cols-1 gap-5 lg:grid-cols-2">
                                    <div className="mb-0">
                                        <label
                                            htmlFor="currency"
                                            className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
                                        >
                                            Prix cible*
                                        </label>
                                        <div className="mt-2 w-full rounded-xl border border-gray-200 px-2.5 py-3 text-sm text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800">
                                            <select
                                                id="targetPrice"
                                                className="mb-0 w-full bg-white dark:!bg-navy-800"
                                                onChange={handlechange}
                                            >
                                                {getPricing().map(
                                                    (price: string) => (
                                                        <option value={price}>
                                                            {price}
                                                        </option>
                                                    )
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    {/* Buyer offer */}
                                    <InputField
                                        label="Quantité de leads (min 40, max 500)"
                                        placeholder="255"
                                        id="weeklyQuantity"
                                        type="number"
                                        onChange={handlechange}
                                    />
                                </div>
                                <div className="col-span-12 mt-3">
                                    <label
                                        htmlFor="currency"
                                        className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
                                    >
                                        Critères de votre lead
                                    </label>
                                    <div className="ml-3 mt-4 grid grid-cols-12">
                                        {(() => {
                                            const currentIndustry = industriesData.find(i => i.name === industry);
                                            const allFields = currentIndustry 
                                                ? [...currentIndustry.fields, 'Téléphone', 'Email', 'Nom', 'Prénom']
                                                : ['Téléphone', 'Email', 'Nom', 'Prénom'];
                                            
                                            return [...new Set(allFields)].reverse().map((field: string) => (
                                                <div key={field} className="col-span-4 mt-2">
                                                    <Checkbox
                                                        defaultChecked={['Téléphone', 'Nom', 'Prénom'].includes(field)}
                                                        id={field}
                                                        extra="mt-1"
                                                        onChange={handleFieldsChange}
                                                    />
                                                    <p>{field}</p>
                                                </div>
                                            ));
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="bottom-3 left-0 ml-7 mt-6 flex h-[40px] w-[155px] gap-2 rounded-xl border px-4 hover:cursor-pointer hover:bg-gray-100 lg:absolute"
                        onClick={() =>
                            window.open('https://wa.me/447458107868 ', '_blank')
                        }
                    >
                        <MdOutlineWhatsapp className="my-auto" />
                        <p className="my-auto flex text-sm">Besoin d'aide ?</p>
                    </div>
                    {/* navigation button */}
                    <div className="flex justify-end text-center">
                        {steps[currentStep - 1].stepNo === 2 && (
                            <button
                                onClick={() => setCurrentStep(1)}
                                className="mt-5 text-sm"
                            >
                                Retour
                            </button>
                        )}
                        <StepperControl
                            handleClick={handleClick}
                            currentStep={currentStep}
                            steps={steps}
                        />
                    </div>
                </Card>
            </div>
            <SignUpModal
                isOpen={showSignUpModal}
                onClose={(accountCreated: boolean) => {    
                    setShowSignUpModal(false);
                    if (accountCreated) createOffer();
                }}
            />
                </>
            )}
        </div>
    );
};

export default ProductNew;
